import { FC } from 'react'

import {
  ConfigFormTemplate,
  InputSelectControlField
} from 'Automations/nodeDefinitions/components'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import { Config } from '.'
import { actionTypeLabel, actionTypeTargetDefinition } from '..'

export const ActionContractExtractionNodeConfigForm: FC<ConfigFormProps> = ({
  nodeId
}) => {
  const { nodeData, updateNodeType, definition, validationErrors } =
    useNode<Config>({ nodeId })

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Action">
        <InputSelectControlField
          value={nodeData.actionType}
          placeholder="Select action..."
          options={Object.entries(actionTypeLabel).map(([value, label]) => ({
            value,
            label
          }))}
          onChange={reviewType => {
            updateNodeType(
              actionTypeTargetDefinition[reviewType as Config['actionType']]
            )
          }}
          validationErrors={validationErrors.actionType}
          data-testid="automations.editor.configForm.action.actionType"
        />
      </ConfigFormTemplate.Row>
    </ConfigFormTemplate>
  )
}
